<template>
  <div>
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3ea56e" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-card tile flat :max-width="widthOfCard">
      <!-- <v-img :src="getImageURL(product.image)" height="200px" cover></v-img> -->
      <v-img
        :src="baseURL + 'u/' + storage.product.photos[0]"
        height="150px"
        contain
      >
        <v-layout wrap>
          <v-flex text-right pa-0>
            <v-avatar color="#FF3434" size="15">
              <v-icon color="#FFF" small @click="removeFromWishlist">
                mdi-close
              </v-icon>
            </v-avatar>
          </v-flex>
        </v-layout>
        <template v-slot:placeholder> <ImageLoader /> </template>
      </v-img>
      <v-layout wrap justify-center px-2>
        <v-flex
          pt-2
          xs12
          text-left
          style="line-height: 16px; cursor: pointer"
          @click="
            $router.push(
              '/productdetailview/' + storage.product.urlname
            )
          "
        >
          <span
            style="
              font-family: poppinssemibold;
              font-size: 13px;
              color: #000000;
            "
          >
            {{ storage.product.productname.slice(0, 25) }}
            <span v-if="storage.product.productname.length > 25"> ... </span>
          </span>
          <br />
          <span
            style="font-family: poppinsregular; font-size: 13px; color: #000000"
          >
            <!-- {{ storage.seller.organization }} -->
          </span>
          <br />
          <span
            style="
              font-family: poppinssemibold;
              font-size: 13px;
              color: #000000;
            "
          >
            Rs. {{ storage.product.price }}
          </span>
          <span
            class="pl-12 text-decoration-line-through"
            style="font-family: poppinsregular; font-size: 13px; color: #ff0000"
          >
            Rs. {{ storage.product.orginalprice }}
          </span>
          <br />
          <span>
            <v-rating
              v-model="storage.product.ratingcount"
              color="#FFD341"
              background-color="#e0e0e0"
              empty-icon="$ratingFull"
              half-increments
              readonly
              hover
              small
            ></v-rating>
          </span>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex xs12 px-2>
          <v-btn
            block
            tile
            color="#E9E9E9"
            dark
            :ripple="false"
            depressed
            @click="addToCart"
            :loading="cartLoading"
          >
            <span
              style="
                font-family: poppinssemibold;
                font-size: 15px;
                text-transform: none;
                color: #000000;
              "
            >
              Add to Cart
            </span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage", "cardWidth"],
  data() {
    return {
      widthOfCard: "250px",
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      ServerError: false,
      cartLoading: false,
    };
  },
  beforeMount() {
    if (this.cardWidth) {
      this.widthOfCard = this.cardWidth;
    }
  },
  methods: {
    removeFromWishlist() {
      var product = {};
      product["productid"] = this.storage.product._id;
      this.appLoading = true;
      
      var headers1 = {};
      if (this.$store.state.isLoggedIn) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        product["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "POST",
        url: "/WishList/Remove",
        data: product,
        headers: headers1,
      })
        .then((response) => {
          this.appLoading = false;
          this.$store.commit("changeWishlist", response.data.wishlistcount);
          if (response.data.status) {
            this.$emit("stepper", {
              ref: "remove",
              response: response.data,
              getData: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addToCart() {
      this.cartLoading = true;
      var cart = {};
      cart["productid"] = this.storage.product._id;
      cart["quantity"] = 1;
      cart["size"] = this.storage.size;
      cart["addonly"] = true;
      
      var headers1 = {};
      if (this.$store.state.isLoggedIn) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        cart["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "POST",
        url: "/Cart/Addorupdate",
        data: cart,
        headers: headers1,
      })
        .then((response) => {
          if (response.data.status) {
            this.cartLoading = false;
            this.$store.commit("changeCart", response.data.count);
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.cartLoading = false;
          console.log(err);
        });
    },
  },
};
</script>